import React, { Fragment, } from 'react';
import { Route, Routes } from 'react-router-dom';
import { superAdminRoutes } from './SuperAdminRoutes';
import { adminRoutes } from './AdminRoutes';
import { csRoutes } from './CsRoutes';
import Layout from '../Layout/Layout';
import ErrorPage1 from 'Component/Pages/ErrorPages/error-page1';
import { GetAdminRole } from 'Component/Common/GetAdminRole';

const LayoutRoutes = () => {
  const user = JSON.parse(localStorage.getItem('USER'));
  const role = GetAdminRole(user);

  const roleRoutes = {
    super_admin: superAdminRoutes,
    admin: adminRoutes,
    cs: csRoutes,
  };

  const routes = roleRoutes[role] || [];
  return (
    <Fragment>
      <Routes>
        {routes.map(({ path, Component }, i) => (
          <Route element={<Layout />} key={i}>
            <Route path={path} element={Component} />
          </Route>
        ))}
        <Route element={<Layout />}>
          <Route path="*" element={<ErrorPage1 />} />
        </Route>
      </Routes>
    </Fragment >
  );
};

export default LayoutRoutes;